import JSIBase from "./base";


export default class JSIiOS extends JSIBase {
    counts = 0;
    callbacks = {};

    constructor() {
        super();

        window.addEventListener("message", event => this.response(event));
    }

    /**
     *
     * @param action
     * @param payload
     * @param callback
     */
    call(action, payload=null, callback=true) {
        const cbid = "cb_" + (++this.counts);
        return new Promise(resolve => {
            if(callback) this.callbacks[cbid] = resolve;

            try {
                // noinspection JSUnresolvedReference
                window.webkit.messageHandlers.Interface.postMessage(JSON.stringify(
                    {
                        cbid, action, payload
                    }
                ));
            } catch (e) {}
        });
    }

    /**
     *
     * @param event
     */
    response(event) {
        const json = event && event.data;
        if(json !== null) {
            const {cbid, ...response} = json;
            const resolve = this.callbacks[cbid] || null;
            if(!resolve) return;
            resolve.call(null, response);
            delete this.callbacks[cbid];
        }
    }


    jsi_open_browser(url) {
        this.call(this.jsi_open_browser.name, {url}).then(() => {

        });
    }

    /**
     * @returns {number}
     */
    jsi_milliseconds() {
        // const response = await this.call(this.jsi_milliseconds.name, null);
        // return (response && response.milliseconds) || super.jsi_milliseconds();
        return super.jsi_milliseconds();
    }

    async jsi_get_id() {
        const response = await this.call(this.jsi_get_id.name, null);
        return (response && response.id) || null;
    }

    async jsi_get_mac() {
        const response = await this.call(this.jsi_get_mac.name, null);
        return (response && response.mac) || null;
    }

    jsi_logout() {
        this.call(this.jsi_logout.name, null).then();
    }

    jsi_login(id, pw) {
        this.call(this.jsi_login.name, {id, pw}).then();
    }

    /**
     * @returns {boolean}
     */
    async jsi_is_play() {
        const response = await this.call(this.jsi_is_play.name, null);
        return (response && response.playing) || false;
    }

    jsi_change_channel(id, title) {
        this.call(this.jsi_change_channel.name, {id, title}).then();
    }

    async jsi_get_info() {
        const response = await this.call(this.jsi_get_info.name, null);
        return (response && response.info) || null;
    }

    /**
     * @returns {number} 0,1,-1
     */
    async jsi_network_state() {
        const response = await this.call(this.jsi_network_state.name, null);
        return (response && response.state) || -1;
    }

    jsi_set_mute(type, value) {
        this.call(this.jsi_set_mute.name, {type, value}).then();
    }

    jsi_set_volume(type, mode, value) {
        this.call(this.jsi_set_volume.name, {type, mode, value}).then();
    }

    jsi_download(url, filename) {
        this.call(this.jsi_download.name, {url, filename}).then();
    }

    jsi_notification(message) {
        this.call(this.jsi_notification.name, {message}).then();
    }

    jsi_set_page_code(code) {
        this.call(this.jsi_set_page_code.name, {code}).then();
    }
}


// WEBPACK FOOTER //
// ./src/vars/interfaces/ios.js